import animateProperty from '../utils/animate-property'
import { getElementVerticalMetrics } from '../utils/get-element-metrics'

class InPageAnchors {

	//Inspired by https://css-tricks.com/smooth-scrolling-accessibility/

	constructor(el, offset, onLoadAnchor) {
		this.el = el;

		this.offset = offset ? offset : 0;

		this.bodyRef = document.querySelectorAll('body')[0]
		this.htmlRef = document.querySelectorAll('html')[0]

		if ( onLoadAnchor ) {

			this.hashTarget = window.location.hash;
			if ( this.hashTarget ) {
				this.targetElement = document.querySelector(this.hashTarget);

				if ( this.targetElement instanceof HTMLElement ) {

					var metrics = getElementVerticalMetrics(this.targetElement);
					this.targetTop = metrics.pageOffsetTop - this.offset;

					this.targetTop -= 50;


					animateProperty(this.bodyRef, 'scrollTop', this.targetTop, () => {}, 2000);
					animateProperty(this.htmlRef, 'scrollTop', this.targetTop, () => {}, 2000);
				}
			}
		}
		else {

			this.target = null;
			this.locationPath = this._filterPath(window.location.pathname);
			this.thisPath = this._filterPath(this.el.pathname) || this.locationPath;

			this.hashTarget = this.el.hash;
			this.hashTargetStripped = this.hashTarget.replace(/#/, '');

			this.targetElements = document.querySelectorAll("#" + this.hashTargetStripped);

			if (this.targetElements.length && this.targetElements.length > 0 ) {
				var test1 = ( this.locationPath == this.thisPath ),
					test2 = ( location.hostname == this.el.hostname || !this.el.hostname),
					test3 = ( this.hashTargetStripped != null );

				if ( test1 && test2 && test3 ) {
					this.targetElement = this.targetElements[0];
					if ( this.targetElement instanceof HTMLElement ) {
						this.el.addEventListener('click', this._clickHandler.bind(this) );
						window.addEventListener('resize', this._resizeHandler.bind(this) );
						this._resizeHandler();
					}

				}
			}
		}
	}

	_resizeHandler() {
		var width = window.outerWidth;
		if ( this.savedWindowWidth === width ) return false;
		else {
			this.savedWindowWidth = width;
			this.mobileViewport = true;
			if ( width > 768 ) { //for this component
				this.mobileViewport = false;
			}
		}
	}

	_clickHandler(event){
		event.preventDefault();
		this.targetElement;
		var metrics = getElementVerticalMetrics(this.targetElement);
		this.targetTop = metrics.pageOffsetTop - this.offset;

		// console.log(metrics)
		// console.log(this.targetElement.getAttribute('id'))
		// console.log(this.targetTop)

		animateProperty(this.bodyRef, 'scrollTop', this.targetTop, () => {}, 2000);
		animateProperty(this.htmlRef, 'scrollTop', this.targetTop, () => {

			// this.targetElement.focus();
			// location.hash = this.hashTarget;
			if (document.activeElement === this.targetElement) {
				return false;
			}
			else{
				this.targetElement.setAttribute('tabindex','-1'); //Adding tabindex for elements not focusable
				this.targetElement.focus(); //Setting focus
			}
			// history.pushState(null, null, this.hashTarget);

		}, 2000);
	}

	_filterPath(string) {
		return string
		.replace(/^\//, '')
		.replace(/(index|default).[a-zA-Z]{3,4}$/, '')
		.replace(/\/$/, '');
	}
}

export default InPageAnchors;
